export default __webpack_public_path__ + "images/natus-city.svg";